import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Datastore } from '@freelancer/datastore';
import {
  OnlineOfflineCollection,
  OnlineOfflineUserStatus,
  Thread,
  ThreadsCollection,
  User,
  UsersCollection,
} from '@freelancer/datastore/collections';
import { flatten } from '@freelancer/utils';
import { FolderApi } from 'api-typings/messages/messages_types';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-messages',
  template: `
    <app-messages-list
      flTrackingSection="NavigationPrimary"
      [onlineOfflineStatuses$]="onlineOfflineStatuses$"
      [threads]="threads$ | async"
      [users]="users$ | async"
    ></app-messages-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagesComponent implements OnInit {
  onlineOfflineStatuses$: Rx.Observable<ReadonlyArray<OnlineOfflineUserStatus>>;
  threads$: Rx.Observable<ReadonlyArray<Thread>>;
  userIds$: Rx.Observable<ReadonlyArray<number>>;
  users$: Rx.Observable<ReadonlyArray<User>>;

  constructor(private datastore: Datastore) {}

  ngOnInit() {
    // Show threads that are not archived
    this.threads$ = this.datastore
      .collection<ThreadsCollection>('threads', query =>
        query
          .where('folder', 'in', [
            FolderApi.FREELANCER,
            FolderApi.INBOX,
            FolderApi.SENT,
          ])
          .limit(5),
      )
      .valueChanges()
      .pipe(
        map(threads =>
          [...threads].sort((a, b) => b.timeUpdated - a.timeUpdated),
        ),
      );

    this.userIds$ = this.threads$.pipe(
      map(ts => flatten(ts.map(t => t.members))),
      map(members => Array.from(new Set(members))),
    );

    this.users$ = this.datastore
      .collection<UsersCollection>('users', this.userIds$)
      .valueChanges();

    this.onlineOfflineStatuses$ = this.datastore
      .collection<OnlineOfflineCollection>('onlineOffline', this.userIds$)
      .valueChanges();
  }
}
